import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/* Layout */
import Layout from "../views/layout/Layout";

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true
  },
  { path: "/404", component: () => import("@/views/404"), hidden: true },
  {
    path: "",
    component: Layout,
    redirect: "/home",
    children: [
      {
        path: "home",
        name: "home",
        component: () => import("@/views/home/index"),
        meta: { title: "首页", icon: "home" }
      }
    ]
  }
];

export const asyncRouterMap = [
  {
    path: "/admin",
    component: Layout,
    redirect: "/admin",
    name: "admin",
    children: [
      {
        path: "admin",
        name: "admin",
        component: () => import("@/views/admin/index"),
        meta: { title: "管理员列表", icon: "product-list" }
      },
      {
        path: "adminAdd",
        name: "adminAdd",
        component: () => import("@/views/admin/add"),
        meta: { title: "新增管理员", icon: "product-list" },
        hidden: true
      },
      {
        path: "adminEdit",
        name: "adminEdit",
        component: () => import("@/views/admin/edit"),
        meta: { title: "编辑管理员", icon: "product-list" },
        hidden: true
      },
      {
        path: "adminWatch",
        name: "adminWatch",
        component: () => import("@/views/admin/watch"),
        meta: { title: "查看新增管理员", icon: "product-list" },
        hidden: true
      }
    ]
  },
  {
    path: "/role",
    component: Layout,
    redirect: "/role",
    name: "role",
    children: [
      {
        path: "role",
        name: "role",
        component: () => import("@/views/role/index"),
        meta: { title: "角色列表", icon: "role" }
      }
    ]
  },
  {
    path: "/company",
    component: Layout,
    redirect: "/company",
    name: "company",
    children: [
      {
        path: "company",
        name: "company",
        component: () => import("@/views/company/index"),
        meta: { title: "企业列表", icon: "sysShop" }
      },
      {
        path: "companyAdd",
        name: "companyAdd",
        component: () => import("@/views/company/add"),
        meta: { title: "新增企业", icon: "sysShop" },
        hidden: true
      },
      {
        path: "companyUpdate",
        name: "companyUpdate",
        component: () => import("@/views/company/update"),
        meta: { title: "编辑企业", icon: "sysShop" },
        hidden: true
      },

      {
        path: "companyHistory",
        name: "companyHistory",
        component: () => import("@/views/company/history"),
        meta: { title: "查看企业", icon: "sysShop" },
        hidden: true
      }
    ]
  },
  {
    path: "/category",
    component: Layout,
    redirect: "/category/category",
    name: "pet",
    meta: { title: "宠物相关", icon: "product-brand" },
    children: [
      {
        path: "category",
        name: "category",
        component: () => import("@/views/category/index"),
        meta: { title: "宠物分类", icon: "category" }
      },
      {
        path: "categoryAdd",
        name: "categoryAdd",
        component: () => import("@/views/category/add"),
        meta: { title: "新增宠物分类", icon: "category" },
        hidden: true
      },
      {
        path: "categoryUpdate",
        name: "categoryUpdate",
        component: () => import("@/views/category/update"),
        meta: { title: "编辑宠物分类", icon: "category" },
        hidden: true
      }
    ]
  },
  {
    path: "/medical",
    component: Layout,
    redirect: "/medical/commondisease",
    name: "medical",
    meta: { title: "医疗相关", icon: "order" },
    children: [
      {
        path: "commondisease",
        name: "commondisease",
        component: () => import("@/views/medical/commondisease/index"),
        meta: { title: "常见病症", icon: "commondisease" }
      },
      {
        path: "commondiseaseAdd",
        name: "commondiseaseAdd",
        component: () => import("@/views/medical/commondisease/add"),
        meta: { title: "新增常见病症", icon: "commondisease" },
        hidden: true
      },
      {
        path: "commondiseaseUpdate",
        name: "commondiseaseUpdate",
        component: () => import("@/views/medical/commondisease/update"),
        meta: { title: "编辑常见病症", icon: "commondisease" },
        hidden: true
      },
      {
        path: "expellinginsects",
        name: "expellinginsects",
        component: () => import("@/views/medical/expellinginsects/index"),
        meta: { title: "宠物驱虫", icon: "expellinginsects" }
      },
      {
        path: "expellinginsectsAdd",
        name: "expellinginsectsAdd",
        component: () => import("@/views/medical/expellinginsects/add"),
        meta: { title: "新增宠物驱虫", icon: "expellinginsects" },
        hidden: true
      },
      {
        path: "expellinginsectsUpdate",
        name: "expellinginsectsUpdate",
        component: () => import("@/views/medical/expellinginsects/update"),
        meta: { title: "编辑宠物驱虫", icon: "expellinginsects" },
        hidden: true
      },
      {
        path: "vaccine",
        name: "vaccine",
        component: () => import("@/views/medical/vaccine/index"),
        meta: { title: "宠物疫苗", icon: "vaccine" }
      },
      {
        path: "vaccineAdd",
        name: "vaccineAdd",
        component: () => import("@/views/medical/vaccine/add"),
        meta: { title: "新增宠物疫苗", icon: "vaccine" },
        hidden: true
      },
      {
        path: "vaccineUpdate",
        name: "vaccineUpdate",
        component: () => import("@/views/medical/vaccine/update"),
        meta: { title: "编辑宠物疫苗", icon: "vaccine" },
        hidden: true
      }
    ]
  },
  // {
  //   path: "/store",
  //   component: Layout,
  //   redirect: "/store/store",
  //   name: "warehouse",
  //   meta: { title: "仓库管理", icon: "store" },
  //   children: [
  //     {
  //       path: "store",
  //       name: "warehousecategory",
  //       component: () => import("@/views/store/index"),
  //       meta: { title: "仓库分类", icon: "store" }
  //     },
  //     {
  //       path: "storeAdd",
  //       name: "warehousecategoryAdd",
  //       component: () => import("@/views/store/add"),
  //       meta: { title: "新增仓库分类", icon: "store" },
  //       hidden: true
  //     },
  //     {
  //       path: "storeUpdate",
  //       name: "warehousecategoryUpdate",
  //       component: () => import("@/views/store/update"),
  //       meta: { title: "编辑仓库分类", icon: "store" },
  //       hidden: true
  //     }
  //   ]
  // },
  { path: "*", redirect: "/404", hidden: true }
];

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
});



// WEBPACK FOOTER //
// ./src/router/index.js